define([
], function () {
  // This class creates appropriate sized circle SVG for the progress indicator
  class SpinnerView {
    createWidget (size) {
      const baseClass = 'mw-progress-indicator';
      let circleAttrs = {};
      let shadowPathDValue;

      switch (size) {
        case 'xsmall':
          circleAttrs = {
            radius: 6.5,
            strokeWidth: 3
          };
          shadowPathDValue = 'M0,-7a8,8,0,0,1,8,7.5A3.81,3.81,0,0,0,8,0A8,8,0,0,0,-8,0a4.19,4.19,0,0,0,0,.5A8,8,0,0,1,0,-7Z';
          break;
        case 'small':
          circleAttrs = {
            radius: 10,
            strokeWidth: 4
          };
          shadowPathDValue = 'M0,-11A12,12,0,0,1,12,.5c0-.17,0-.33,0-.5A12,12,0,0,0,-12,0c0,.17,0,.33,0,.5A12,12,0,0,1,0,-11Z';
          break;
        case 'medium':
          circleAttrs = {
            radius: 13.5,
            strokeWidth: 5
          };
          shadowPathDValue = 'M0,-15A16,16,0,0,1,16,.5c0-.17,0-.33,0-.5A16,16,0,0,0,-16,0c0,.17,0,.33,0,.5A16,16,0,0,1,0,-15Z';
          break;
        case 'large':
          circleAttrs = {
            radius: 21,
            strokeWidth: 6
          };
          shadowPathDValue = 'M 0,-22A24,24,0,0,1,24,1c0-.33,0-.66,0-1A24,24,0,0,0,-24,0c0,.34,0,.67,0,1A24,24,0,0,1,0,-22Z';
          break;
        case 'xlarge':
          circleAttrs = {
            radius: 29,
            strokeWidth: 6
          };
          shadowPathDValue = 'M 0,-29A32,32,0,0,1,32,1.5c0-.5,0-1,0-1.5A32,32,0,0,0,-32,0c0,.5,0,1,0,1.5A32,32,0,0,1,0,-29Z';
          break;
      }
      // Center Coordinates
      circleAttrs.cx = 0;
      circleAttrs.cy = 0;
      let dummyDiv = document.createElement('div');

      let svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgNode.setAttribute('class', 'progressIndicatorSvg');
      svgNode.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
      svgNode.setAttribute('width', '100%');
      svgNode.setAttribute('height', '100%');
      svgNode.setAttribute('viewBox', `${-(circleAttrs.radius + circleAttrs.strokeWidth / 2)} ${-(circleAttrs.radius + circleAttrs.strokeWidth / 2)} ${2 * (circleAttrs.radius + circleAttrs.strokeWidth / 2)} ${2 * (circleAttrs.radius + circleAttrs.strokeWidth / 2)}`);
      let group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      let progressIndicatorGutter = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      progressIndicatorGutter.classList.add(`${baseClass}-gutter`);
      progressIndicatorGutter.setAttribute('r', circleAttrs.radius);
      progressIndicatorGutter.setAttribute('cx', circleAttrs.cx);
      progressIndicatorGutter.setAttribute('cy', circleAttrs.cy);
      let progressIndicatorArt = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      progressIndicatorArt.classList.add(`${baseClass}`);
      progressIndicatorArt.setAttribute('r', circleAttrs.radius);
      progressIndicatorArt.setAttribute('cx', circleAttrs.cx);
      progressIndicatorArt.setAttribute('cy', circleAttrs.cy);
      let shadowPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      shadowPath.setAttribute('d', `${shadowPathDValue}`);
      shadowPath.classList.add(`${baseClass}-shadow`);
      group.appendChild(progressIndicatorGutter);
      group.appendChild(progressIndicatorArt);
      svgNode.appendChild(group);
      svgNode.appendChild(shadowPath);
      dummyDiv.appendChild(svgNode);
      const valueLength = 2 * Math.PI * circleAttrs.radius;

      let svg = dummyDiv.firstChild;
      dummyDiv = null;
      let returnvalue = {
        valueLength: valueLength,
        svg: svg

      };
      return returnvalue;
    }
  }
  return SpinnerView;
});
